import { h, Component } from 'preact'
import PropTypes from 'prop-types'

import Modal from '../Modal'
import Button from '../Button'

import './index.sass'

export default class AlertModal extends Component {

  static propTypes = {
    className: PropTypes.string,
    onClose: Modal.propTypes.onClose,
    narrow: PropTypes.bool,
    buttons: PropTypes.arrayOf(PropTypes.node),
    children: Modal.propTypes.children,
  }

  componentDidMount(){
    this.closeButton.base.focus()
  }

  render(){
    const {
      className = '',
      onClose,
      narrow,
      buttons,
      children,
      ...props
    } = this.props

    return <Modal
      {...props}
      onClose={onClose}
      className={`AlertModal ${className} ${narrow ? 'AlertModal-narrow' : ''}`}
    >
      <div className="AlertModal-content">
        {children}
      </div>
      <div className="AlertModal-buttons">
        {buttons}
        <Button
          ref={node => { this.closeButton = node }}
          type="normal"
          value="close"
          onClick={onClose}
        />
      </div>
    </Modal>
  }
}
